// libs
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

// defs
import { AppState } from './types';

export const useIsUserDataFetching = (): AppState['user']['isFetching'] =>
  useSelector((state: { app: AppState }) => get(state, 'app.user.isFetching', true));

export const useIsUserLoggedIn = () =>
  useSelector((state: { app: AppState }) => isEmpty(get(state, 'app.user.customerData')) === false);

export const useCustomerData = (): AppState['user']['customerData'] =>
  useSelector((state: { app: AppState }) => get(state, 'app.user.customerData'));

export const useCustomerInfo = (): AppState['user'] =>
  useSelector((state: { app: AppState }) => get(state, 'app.user'));
